export default "__VITE_ASSET__6xeqGYEG__"